import { combineReducers } from '@reduxjs/toolkit';
// import userReducer from './user/userReducer'
import userReducer from './slices/userSlice';
import authReducer from './slices/auth';
import fileReducer from './slices/files';
import userfoldersReducer from './slices/userfolders';
import configReducer from './slices/configSlice';
// import dashboardSlice from "./slices/dashboardSlice";
import blocksReducer from './slices/blocksSlice';
import popupReducer from './slices/popupSlice';
// import connectionReducer from './slices/databaseConnectionSlice';
import workerReducer from './slices/workersSlice';
import tablesReducer from './slices/tablesSlice';
import tableRowReducer from './slices/tableRowSlice';
import connectionsReducer from './slices/connectionsSlice';
import workflowsReducer from './slices/workflowsSlice';
import customerNodeDefinitionsReducer from './slices/customer_node_definitionsSlice';
import eventsReducer from './slices/eventsSlice';
import nodeTypesReducer from './slices/lists/nodeTypesSlice';
import zonesReducer from './slices/lists/zonesSlice';
import connectionReducer from './slices/lists/connectionsSlice';
import parameterTypesReducer from './slices/lists/parameterTypesSlice';
import reportsReducer from './slices/reportsSlice';
import flatNodeInstancesReducer from './slices/instances/flatNodeInstancesSlice';
import auditTrailsReducer from './slices/audit_trailSlice';
import nodeInstancesReducer from './slices/node_instancesSlice';
import queuesReducer from './slices/lists/queuesSlice';
import nodeSubmitReducer from './slices/nodeSubmitSlice';
import nodePanelReducer from './slices/panelSlice';
import eventInstanceHistoryReducer from './slices/eventInstanceHistorySlice';
import schedulingWindowReducer from './slices/scheduling_windowsSlice';
import filtersSliceReducer from './slices/filtersSlice';
import locksReducer from './slices/locksSlice';
import rolesReducer from './slices/rolesSlice';
import systemInfoReducer from './slices/systemInfoSlice';
import recurrenceDefinitionsReducer from './slices/recurrenceDefinitionsSlice';
import triggersReducer from './slices/triggersSlice';
import foldersReducer from './slices/lists/foldersSlice';
import integrationsReducer from './slices/lists/integrationsSlice';
import integrationNodesReducer from './slices/lists/integrationNodesSlice';
import monitoringDashboardsReducer from './slices/monitoringDashboardsSlice';
import transportsReducer from './slices/transportsSlice';
import pythonLibrariesReducer from './slices/pythonLibrariesSlice';

const rootReducer = combineReducers({
  user: userReducer,
  auth: authReducer,
  files: fileReducer,
  userfolders: userfoldersReducer,
  config: configReducer,
  // dashboard: dashboardSlice,
  blocks: blocksReducer,
  popups: popupReducer,
  // connections: connectionReducer,
  workers: workerReducer,
  tables: tablesReducer,
  tableRows: tableRowReducer,
  connections: connectionsReducer,
  workflows: workflowsReducer,
  customerNodeDefinitions: customerNodeDefinitionsReducer,
  events: eventsReducer,
  eventInstanceHistory: eventInstanceHistoryReducer,
  listOfQueues: queuesReducer,
  listOfNodeTypes: nodeTypesReducer,
  listOfZones: zonesReducer,
  listOfConnections: connectionReducer,
  listOfParameterTypes: parameterTypesReducer,
  auditTrails: auditTrailsReducer,
  reports: reportsReducer,
  nodeInstances: nodeInstancesReducer,
  queues: queuesReducer,
  flatNodeInstances: flatNodeInstancesReducer,
  nodeSubmit: nodeSubmitReducer,
  bottomPanel: nodePanelReducer,
  schedulingWindow: schedulingWindowReducer,
  filters: filtersSliceReducer,
  locks: locksReducer,
  roles: rolesReducer,
  systemInfo: systemInfoReducer,
  recurrenceDefinitions: recurrenceDefinitionsReducer,
  triggers: triggersReducer,
  listOfFolders: foldersReducer,
  listOfIntegrations: integrationsReducer,
  listOfIntegrationNodes: integrationNodesReducer,
  monitoringDashboards: monitoringDashboardsReducer,
  transports: transportsReducer,
  pythonLibraries: pythonLibrariesReducer,
});

export default rootReducer;
